export default function imageSizeFromSanityAssetRef(ref: string) {
  // eg: image-d6918ffd16f44428dc9318859ecfc867f7e44413-4000x2668-jpg
  const match = ref.match(/^image-\w+-(\d+)x(\d+)-\w+$/);
  if (!match) throw new Error('Invalid image ref');
  return [parseInt(match[1], 10), parseInt(match[2], 10)] as const;
}
